import type { TemplatePurpose } from '@brush/api-client';

/**
 * What the platform does with a template, in the room's own words.
 *
 * A room cannot choose these — the platform assigns one per template — so this side only needs
 * to say what a purpose *means for the room*: `general` is a document to use as they like, and
 * the importing ones are templates an importer reads.
 *
 * `general` has no label on purpose. It is the ordinary case and naming it on every row would
 * spend a line saying "nothing special about this one"; the templates that do something are the
 * ones worth marking.
 */
const PURPOSE_LABELS: Record<TemplatePurpose, string | null> = {
  general: null,
  import_tournaments: 'Importing tournaments',
  import_tournament_results: 'Importing results',
  import_players: 'Importing players',
};

/** The room-facing label, or null where the purpose is the ordinary one or is not known here. */
export const purposeLabel = (purpose: string): string | null =>
  PURPOSE_LABELS[purpose as TemplatePurpose] ?? null;
